import React from "react";
import { Box, Typography, Paper, Grid, Button } from "@mui/material";
import CustomerLayout from "../CustomerLayout";

const KnowledgeBase = () => {
  const articles = [
    {
      title: "Posting a Load",
      text: "Create a load request with route, freight, handling, and pricing details.",
      link: "/customer/getting-started-guides",
    },
    {
      title: "Tracking a Load",
      text: "Review load status, estimated arrival, route activity, and tracking updates.",
      link: "/customer/track-package",
    },
    {
      title: "Payments",
      text: "Review payment activity, invoices, receipts, and billing history.",
      link: "/customer/payment-management",
    },
    {
      title: "Driver / Carrier Communication",
      text: "Communicate with assigned drivers or carriers regarding load activity, routing, pickup coordination, and transport updates.",
      link: "/customer/customer-courier-communication",
    },
  ];

  return (
    <CustomerLayout>
      <Box sx={{ maxWidth: 980, mx: "auto", py: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            letterSpacing: "-0.02em",
            mb: 1,
          }}
        >
          Knowledge Base
        </Typography>

        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            lineHeight: 1.6,
            mb: 4,
            maxWidth: 820,
          }}
        >
          Quick guidance for using HaggleFreight’s load management, 
          carrier communication, payment, and support tools.
        </Typography>

        <Grid container spacing={2}>
          {articles.map((item) => (
            <Grid item xs={12} md={6} key={item.title}>
              <Paper
                elevation={0}
                sx={{
                  height: "100%",
                  border: "1px solid #e5e7eb",
                  borderRadius: 3,
                  p: 3,
                  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  {item.title}
                </Typography>

                <Typography
                  color="text.secondary"
                  sx={{ mb: 2.5, minHeight: 48, lineHeight: 1.6 }}
                >
                  {item.text}
                </Typography>

                <Button
                  variant="outlined"
                  href={item.link}
                  sx={{ textTransform: "none", fontWeight: 700 }}
                >
                  Open
                </Button>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </CustomerLayout>
  );
};

export default KnowledgeBase;